import Vue from 'vue';
import _ from 'lodash';
import dottie from 'dottie';
import auth from './auth';

const state = {
  missions: {},
  missionList: [],
  games: {},
  gameList: [],
  roomId: null,
};

const actions = {
  FETCH_MISSIONS: async ({ commit }, { kuzzle, index }) => {
    if (!index) {
      return;
    }

    let privateMissions = await kuzzle.query({
      controller: 'document',
      action: 'search',
      index: index,
      collection: 'missions',
      scroll: '1m',
      size: 1000,
      loggedAsUser:
        auth.state.currentUser && auth.state.currentUser.loggedAsUser,
    });

    console.log('privateMissions:', privateMissions.result.hits.length);
    const publicMissions = await kuzzle.document.search(
      'public',
      'missionstemplates',
      {},
      {
        scroll: '1m',
        size: 1000,
      }
    );
    privateMissions.result.hits.map((mission) => {
      mission._source._index = index;
    });
    publicMissions.hits.map((mission) => {
      mission._source._index = 'public';
    });
    let searchedMissions = privateMissions.result.hits.concat(
      publicMissions.hits
    );
    // TMP mapping rajout du nouveau champ isComplete si non existant, valeur par défault true car si l mission existe elle est bien complete
    searchedMissions.map((mission) => {
      if (!mission._source.isComplete) {
        mission._source.isComplete = { fr: true, en: false };
      }
      return mission;
    });

    commit('RESET_MISSIONS');

    searchedMissions.forEach((mission) => {
      mission._source.games.forEach((game) => {
        commit('ADD_GAME', game);
      });
      mission._source.games = mission._source.games.map((game) => game.gameId);
      commit('ADD_MISSION', mission);
    });
    console.log('fetch missions Ok');
  },
  SUBSCRIBE: async ({ commit }, { kuzzle, index }) => {
    if (!index) {
      return;
    }
    const roomId = await kuzzle.realtime.subscribe(
      index,
      'missions',
      {
        loggedAsUser:
          auth.state.currentUser && auth.state.currentUser.loggedAsUser,
      },
      (notification) => {
        switch (notification.action) {
          case 'update':
            notification.result._source.games.forEach((game) => {
              commit('ADD_GAME', game);
            });
            notification.result._source._index = index;
            commit('UPDATE_MISSION', {
              missionId: notification.result._id,
              missionPayload: notification.result._source,
            });

            break;
          case 'delete':
            commit('DELETE_MISSION', notification.result._id);
            break;
          case 'create':
            notification.result._source._index = index;
            notification.result._source.games.forEach((game) => {
              commit('ADD_GAME', game);
            });
            notification.result._source.games =
              notification.result._source.games.map((game) => game.gameId);
            commit('ADD_MISSION', notification.result);
            break;
          case 'mUpdate':
            notification.result._source.games.forEach((game) => {
              commit('ADD_GAME', game);
            });
            notification.result._source._index = index;
            commit('UPDATE_MISSION', {
              missionId: notification.result._id,
              missionPayload: notification.result._source,
            });
            break;
        }
      },
      { scope: 'all' }
    );
    commit('SET_ROOM_ID', roomId);
    console.log('subscribe ok');
  },
  UNSUBSCRIBE: async ({ commit, state }, kuzzle) => {
    if (state.roomId) {
      await kuzzle.realtime.unsubscribe(state.roomId);
    }
    commit('SET_ROOM_ID', null);
  },
  CREATE_MISSION: async ({}, { newMissionPayload, kuzzle, index }) => {
    if (!index) {
      return;
    }

    let newMission = await kuzzle.query({
      controller: 'document',
      action: 'create',
      index: index,
      collection: 'missions',
      loggedAsUser:
        auth.state.currentUser && auth.state.currentUser.loggedAsUser,
      body: newMissionPayload,
    });
    console.log('pathCreated: ', newMission);

    return newMission.result;
  },
  DELETE_MISSION: async ({}, { missionId, index, kuzzle }) => {
    if (!index) {
      return;
    }
    await kuzzle.document.delete(index, 'missions', missionId);
  },
  UPDATE_MISSION: async ({}, { missionId, missionPayload, kuzzle, index }) => {
    console.log('action update mission');
    if (missionPayload.hasOwnProperty('pictures')) {
      missionPayload.pictures.forEach((p) => {
        delete p.dataUrl;
      });
    }
    await kuzzle.document.update(index, 'missions', missionId, missionPayload);
    console.log('after document update');
  },
  TRANSLATE_MISSIONS: async (
    {},
    { index, listMissionsIds, originLanguage, targetLanguage, kuzzle }
  ) => {
    console.log('action TRANSLATE_MISSIONS');
    const res = await kuzzle.query({
      controller: 'translate',
      action: 'document',
      body: {
        index: index,
        collection: 'missions',
        docId: listMissionsIds,
        targetLang: targetLanguage,
        originLang: originLanguage,
      },
    });
  },
};

const mutations = {
  RESET_MISSIONS: (state) => {
    state.missions = {};
    state.missionList = [];
    state.games = {};
    state.gameList = [];
  },
  ADD_MISSION: (state, mission) => {
    Vue.set(state.missions, mission._id, mission._source);
    state.missionList = [...state.missionList, mission._id];
  },
  ADD_GAME: (state, game) => {
    // console.log('mute ADD GAME', game);
    Vue.set(state.games, game.gameId, game);
    state.gameList = [...state.gameList, game.gameId];
  },
  UPDATE_MISSION: (state, { missionId, missionPayload }) => {
    missionPayload.games = missionPayload.games.map((game) => game.gameId);
    Vue.set(state.missions, missionId, missionPayload);
  },
  UPDATE_GAME: (state, { gameId, gamePayload }) => {
    dottie.set(state.games[gameId], gamePayload.key, gamePayload.val);
  },
  TRANSLATE_MISSIONS: (state, { missionId, pathPayload }) => {
    Vue.set(state.missions, missionId, pathPayload);
  },
  DELETE_MISSION: (state, missionId) => {
    if (!state.missions[missionId]) {
      return;
    }
    Vue.delete(state.missions, missionId);
  },
  SET_ROOM_ID: (state, roomId) => {
    state.roomId = roomId;
  },
};

const getters = {
  getGames: (state) => {
    return (gameId) => state.games[gameId];
  },
  getMissionGames: (state) => {
    return (missionId) => {
      if (state.missions[missionId]) {
        return state.missions[missionId].games;
      }
      return [];
    };
  },
  getMissionsByIds: (state) => {
    return (missionsIds) => {
      return Object.fromEntries(
        Object.entries(state.missions).filter(([k, v]) =>
          missionsIds.includes(k)
        )
      );
    };
  },
  getMission: (state) => {
    return (missionName) => {
      if (!Object.keys(state.missions).includes(missionName)) {
        return null;
      }
      return state.missions[missionName];
    };
  },
  getMissionById: (state) => {
    return (missionId) => {
      if (!Object.keys(state.missions).includes(missionId)) {
        return null;
      }
      const mission = state.missions[missionId];
      return mission;
    };
  },
  getMissionIdByName: (state) => {
    return (missionName) => {
      let key = 0;
      Object.values(state.missions).some((mission) => {
        key++;
        return mission.name === missionName;
      });
      return Object.keys(state.missions)[key - 1];
    };
  },
  getGameById: (state) => {
    return (gameId) => {
      if (!Object.keys(state.games).includes(gameId)) {
        return null;
      }
      const game = state.games[gameId];
      return game;
    };
  },

  getGamesByIds: (state) => {
    return (gamesIds) => {
      return Object.fromEntries(
        Object.entries(state.games).filter(([k, v]) => gamesIds.includes(k))
      );
    };
  },
  getMissionGamesTypes: (state) => {
    return (missionId) => {
      let gamesIds = [];
      if (state.missions[missionId]) {
        gamesIds = state.missions[missionId].games;
      }
      let types = [];
      if (gamesIds.length > 0) {
        types = gamesIds.map((gameId) => {
          if (!Object.keys(state.games).includes(gameId)) {
            return null;
          }
          const type = state.games[gameId].type;
          return type;
        });
        return types;
      }
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
